import { apiSlice } from "../apiSlice";

//El panel anuncia cada resultado en su propia tarjeta: sin el toast genérico
const SILENCIO = { Notoastxx: "SI" };
const MODIMPXX = { modulecima: "Modimpxx", Notoastxx: "SI" };

/**
 * Marca única por clic: el API devuelve durante un día la misma respuesta a un POST idéntico (middleware de
 * idempotencia) y el segundo clic del simulador nunca correría.
 * @returns {string} Marca
 */
const marca = () => `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;

/**
 * SIMULADOR DEL LABORATORIO: lo que en la vida real hacen otros (la DIAN con el levante, el cliente o el Ejecutivo que
 * responden el correo, Customs AI con la foto del acta firmada) a un clic, y el «Qué pasó» de la entrega al
 * transportador. Todo responde 404 en producción: ahí el panel no existe.
 *
 * @author Claude Code (Alexandra Parra) <direccionit.siaco@repremundo.com.co>
 * @since 2026-10-26
 */
export const simulabApiSlice = apiSlice.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    /** {DISPONIBLE, AMBIENTE, MAILHOG}; 404 en producción */
    getSimulabDisponible: builder.query({
      query: () => ({ url: "/laboratorio/disponible", method: "GET", headers: SILENCIO }),
      keepUnusedDataFor: 600,
    }),
    /** Importaciones recientes para elegir el DO */
    getSimulabOperaciones: builder.query({
      query: ({ BUSCARXX }) => ({ url: "/laboratorio/operaciones", method: "GET", params: { BUSCARXX }, headers: SILENCIO }),
      keepUnusedDataFor: 30,
    }),
    /** Foto de la entrega: bloqueos, tareas, actas, correos, traza */
    getSimulabQuePaso: builder.query({
      query: ({ DOCNROXX }) => ({ url: `/laboratorio/quePaso/${DOCNROXX}`, method: "GET", headers: SILENCIO }),
      keepUnusedDataFor: 0,
    }),
    /** Aceptación de las declaraciones (paso previo al levante) */
    simularAceptacion: builder.mutation({
      query: (body) => ({ url: "/laboratorio/aceptacion", method: "POST", body: { ...body, MARCAXXX: marca() }, headers: SILENCIO }),
    }),
    /** Levante definitivo o especial (TIPOLEVX) */
    simularLevante: builder.mutation({
      query: (body) => ({ url: "/laboratorio/levante", method: "POST", body: { ...body, MARCAXXX: marca() }, headers: SILENCIO }),
    }),
    /** Respuesta del cliente o del Ejecutivo con la instrucción (CANALXXX CORREO_CLIENTE | CORREO_EJECUTIVO) */
    simularInstruccion: builder.mutation({
      query: (body) => ({ url: "/Modimpxx/Emilibxx/Entransx/simulador/instruccion", method: "POST", body: { ...body, MARCAXXX: marca() }, headers: MODIMPXX }),
    }),
    /** Foto del acta firmada (FIRMADA SI | NO) */
    simularActaFirmada: builder.mutation({
      query: (body) => ({ url: "/Modimpxx/Emilibxx/Entransx/simulador/actaFirmada", method: "POST", body: { ...body, MARCAXXX: marca() }, headers: MODIMPXX }),
    }),
  }),
});

export const {
  useGetSimulabDisponibleQuery,
  useGetSimulabOperacionesQuery,
  useLazyGetSimulabQuePasoQuery,
  useSimularAceptacionMutation,
  useSimularLevanteMutation,
  useSimularInstruccionMutation,
  useSimularActaFirmadaMutation,
} = simulabApiSlice;
